<script lang="ts" setup>
    import Cms from "@/components/Cms.vue";
    import MarkdownEditor from "@/components/MarkdownEditor.vue";
    import APIKey from "@/components/APIKey.vue"
    import { computed, ref} from "vue"   
    import { Head } from "@inertiajs/vue3"; 
    import { useDateFormat } from "@vueuse/core";
    import { useGenericStore } from "@/store/genericStore";
    import { storeToRefs } from "pinia";
    import { Link } from "@inertiajs/vue3";
    let { state: availableVersions } = storeToRefs(useGenericStore('availableVersions', []));
    let props = defineProps({
        content: {
            type: Object,
            default: () => ({
                data: {
                    pageName: null,
                    metaDescription: "",
                    metaKeywords: "",
                    versions: []
                }
            })
        },
        api_key: {
            type: Object,
            default: () => ({
                key: ""
            }),
            required: false
        }
    })


    let builderData = ref({
        pageName: null,
        metaDescription: "",
        metaKeywords: ""
    })

    let currentVersion = computed(()=>{
        return props.content?.data?.versions?.find((version: any)=>version.versionNumber === route().params.version) ?? null;
    })
    let deprecated = computed(()=>{
        return currentVersion.value?.deprecated ?? false;
    })

    let removedAt = computed(()=>{
        return currentVersion.value?.removedAt ?? null;
    })
    let removedAtText = computed(()=>{
        return removedAt.value == null ? "in a future release" : useDateFormat(new Date(removedAt.value), "MM/DD/YYYY");
    })
    let isPastRemovedAt = computed(()=>{
        return removedAt.value != null && new Date(removedAt.value) < new Date();
    })
    availableVersions.value = props.content?.data?.versions?.map((version: any)=>{
        return version.versionNumber
    }).sort((a: string, b: string)=>{
        return a.localeCompare(b)
    }) ?? [];

    let searchParams = computed(()=>{
        return {
            "data.pageUrl.$eq": route().params.pageName
        }
    })

let components = [
    {
        name: "Markdown Editor",
        component: MarkdownEditor,
        models: ["content-section"],
        inputs: [{
            name: "markdown",
            type: "longText",
        }]
    }
]

let pageContext = computed(()=>{
    return {
        version: currentVersion.value?.versionNumber
    }
})


let laterVersion = computed(()=>{
    // find the latest version that is not the current version
    return availableVersions.value.find((version: string)=>version !== currentVersion.value?.versionNumber) ?? null;
})

let pageName = computed(()=>{
    return props.content?.data?.pageName ?? builderData.value?.pageName;
})
let metaDescription = computed(()=>{
    return props.content?.data?.metaDescription ?? builderData.value?.metaDescription;
})
let metaKeywords = computed(()=>{
    return props.content?.data?.metaKeywords ?? builderData.value?.metaKeywords;
})

</script>
<template>
    <div class="cms-feature" style="padding: 1.5rem;">
        <Head>
            <title>{{pageName}}</title>
            <meta name="description" :content="metaDescription"/>
            <meta name="keywords" :content="metaKeywords"/>
        </Head>
        <!-- <div > -->
            <div class="notification notification-alert" v-if="deprecated && !isPastRemovedAt">
                <p class="paragraph-details strong">This api is deprecated and will be removed {{ removedAtText }}. <Link v-if="laterVersion" :href="route('api.docs', { pageName: content?.data?.pageUrl, version: laterVersion})"> Try using our latest version!</Link></p>
            </div>
        <!-- </div> -->
    <div class="notification notification-error" v-if="deprecated && isPastRemovedAt">
        <p class="paragraph-details strong">This api is deprecated and has been removed as of {{ removedAtText }}. <Link v-if="laterVersion" :href="route('api.docs', { pageName: content?.data?.pageUrl, version: laterVersion})"> Try using our latest version!</Link></p>
    </div>
    <cms content-prop="content" model="content-section" driver="builder" :readable-fields="['pageName']" :components="components" is-section :search-params="searchParams" :key="currentVersion?.versionNumber" :injected-context="pageContext" v-model="builderData" />
</div>
</template>
